import { getAccessToken as get, setToken } from "../auth";

export const AUTH_START = "AUTH/START";
export const AUTH_SUCCESS = "AUTH/SUCCESS";
export const AUTH_FAILURE = "AUTH/FAILURE";
export const LOG_OUT = "LOG_OUT";

const authStart = () => ({ type: AUTH_START });
const authReceive = () => ({ type: AUTH_SUCCESS });
const authFail = err => ({ type: AUTH_FAILURE, payload: err, error: true });

export function logIn(username, password) {
  return async dispatch => {
    dispatch(authStart());
    try {
      const data = await get(username, password);
      return dispatch(authReceive(data));
    } catch (err) {
      return dispatch(authFail(err));
    }
  };
}

export function logOut() {
  setToken(null);
  return { type: LOG_OUT };
}

const initialState = {
  isAuthenticated: false,
  authenticating: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTH_START:
      return { ...state, authenticating: true };
    case AUTH_SUCCESS:
      return {
        ...state,
        error: null,
        authenticating: false,
        isAuthenticated: true
      };
    case AUTH_FAILURE:
      return { ...initialState, error: action.payload };
    case LOG_OUT:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/ducks/auth.js